<template>
    <footer>
        <div class="container">
            <router-link :to="{ path: '/' }">
                <img src="/img/logo_footer.png">
            </router-link>
            <p>© Minden jog fenntartva! 2018</p>
            <a href="/uploads/CITYAPP_ADATKEZELESI_SZABALYZAT.pdf">Adatkezelési szabályzat</a>
        </div>
    </footer>
</template>

<script>
    export default {
        methods: {
        }
    };
</script>

